/**
 * useHaptics — Sprint E · a tiny helper for tactile-feedback taps.
 *
 * The Vibration API is Android-only (iOS Safari never shipped it and
 * Apple has no plans to). We wrap `navigator.vibrate` so callers can
 * fire micro-tactile ticks on Android + safely no-op on iOS.
 *
 * Three intensity presets:
 *   · tick    — 8 ms  · secondary taps (chips, tabs)
 *   · nudge   — 15 ms · primary taps (nav, card selects)
 *   · commit  — 30 ms · form submits + booking hand-offs
 */
export const HAPTICS = {
  tick:   8,
  nudge:  15,
  commit: 30,
};

export function fireHaptic(intensity = 'nudge') {
  try {
    if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
    const ms = typeof intensity === 'number'
      ? intensity
      : (HAPTICS[intensity] ?? HAPTICS.nudge);
    navigator.vibrate(ms);
  } catch { /* older browsers */ }
}

/**
 * React-friendly hook — returns a stable trigger function.
 */
export default function useHaptics() {
  return fireHaptic;
}
